import React, { useState } from 'react';
import { ArrowUpRight, Instagram, Mail } from 'lucide-react';
import { BRAND, navLinks } from '../brand';
import { LEGAL_LINKS } from './pages/legal';
import { CONFIG } from '../config';
import { isEmailSyntax, subscribeEmail, validateEmail } from '../api';

const EMAIL_ERROR = 'Adresse email invalide, veuillez vérifier votre adresse.';

const TikTokIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 3h-2.7v12.1a2.6 2.6 0 1 1-2-2.5V9.8a5.5 5.5 0 1 0 4.7 5.4V9.1a6.4 6.4 0 0 0 3.8 1.2V7.6a3.8 3.8 0 0 1-3.8-3.8V3z" />
  </svg>
);

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    const v = email.trim();
    if (!isEmailSyntax(v)) { setStatus('err'); return; }
    try { await validateEmail(v); await subscribeEmail(v, 'footer'); setStatus('ok'); setEmail(''); } catch { setStatus('err'); }
  };
  return (
    <form className="footer-news" onSubmit={submit} data-testid="newsletter-form">
      <label htmlFor="nl-email">Reste informé des prochains drops</label>
      <div className="footer-news-row">
        <input id="nl-email" type="email" value={email} onChange={(e) => { setEmail(e.target.value); setStatus(''); }} placeholder="Ton email" data-testid="newsletter-email" />
        <button type="submit" data-testid="newsletter-submit">S&apos;inscrire</button>
      </div>
      {status === 'ok' && <span className="footer-news-msg" data-testid="newsletter-ok">Merci, c&apos;est noté ✓</span>}
      {status === 'err' && <span className="footer-news-msg err" data-testid="newsletter-err">{EMAIL_ERROR}</span>}
    </form>
  );
};

export const Footer = () => (
  <footer className="site-footer">
    <div className="page-width">
      <div className="footer-top"><div><img src={BRAND.logo} alt="Signature WEARHOUSE 60" /><p className="font-display">WEARHOUSE 60</p><span>{BRAND.tagline}</span></div><nav>{navLinks.map(link => <a key={link.id} href={link.href} data-testid={`footer-${link.id}`}>{link.label}<ArrowUpRight size={17} /></a>)}</nav></div>
      <nav className="footer-legal" data-testid="footer-legal">{LEGAL_LINKS.map(link => <a key={link.slug} href={`/${link.slug}`} data-testid={`legal-link-${link.slug}`}>{link.label}</a>)}</nav>
      <Newsletter />
      <nav className="footer-social" data-testid="footer-social">
        <a href={CONFIG.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram" data-testid="footer-instagram"><Instagram size={22} /></a>
        <a href={CONFIG.tiktokUrl} target="_blank" rel="noopener noreferrer" aria-label="TikTok" title="TikTok" data-testid="footer-tiktok"><TikTokIcon /></a>
        <a href={`mailto:${CONFIG.contactEmail}`} aria-label={`Email : ${CONFIG.contactEmail}`} title={CONFIG.contactEmail} data-testid="footer-contact"><Mail size={22} /></a>
      </nav>
      <div className="footer-bottom"><span>© {new Date().getFullYear()} WEARHOUSE 60</span><span>DENIM 14 OZ. CARACTÈRE BRUT.</span><a href="#top" data-testid="back-to-top">RETOUR EN HAUT ↑</a></div>
    </div>
  </footer>
);
export default Footer;